import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-phone-view',
  templateUrl: './phone-view.component.html',
  styleUrls: ['./phone-view.component.scss'],
})
export class PhoneViewComponent implements OnInit {
  @Input() phone: string;

  phoneParsed: string;

  ngOnInit() {
    if (!this.phone) return;
    const phoneParsed = this.phone.replace(/\D/g, '');
    const isCorrectPhone = phoneParsed.length === 10;
    if (!isCorrectPhone) return;
    this.phoneParsed = `tel:+1${phoneParsed}`;
  }
}
